module.exports = __webpack_public_path__ + "static/img/coe-heavy-horse-red.4ca3354.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-heavy-horse-red.svg
// module id = lga0
// module chunks = 74